import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../../components/common/loading';
import Error from '../../../components/common/error';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import Button from '@dbk/ui-buttons';
import { PAPERLESS_OPT_IN_STATUS } from '../../../constants';
import { NotificationWarning } from '@dbk/ui-icons';
import BlurModal from '../../../../src/components/common/blur-modal';
import { ROUTES, MANAGE_CONTACT_DETAILS_CONSTANTS } from '../../../constants';
import { PALETTE } from '../../../constants';
import Popover from '@dbk/ui-popover';
import { Info2 } from '@dbk/ui-icons';
import Modal from '@dbk/ui-modal';
import Text, { Large,H1 } from '@dbk/ui-text';
import { Checkbox } from '@dbk/ui-forms';
import DismissableBar from './dismissable-bar-success';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';

class PaperlessSettings extends PureComponent {
  constructor(props) {
    super(props);
    this.state = ({
      signHrmwAlert: false,
      missingSignFormAlert: false,
      goPaperLessPopup: false,
      otpVerified: false,
    });
  }

  componentDidMount() {
    this.props.paperless.getPaperlessBPList();
    this.props.hrmw.resetFormStatus();
    this.props.paperless.setIsPaperlessSettingsPage(true);
  }

  componentWillUnmount = () => {
    this.props.paperless.setIsPaperlessSettingsPage(false);
  }


  componentWillReceiveProps() {
    if (this.props.hrmw.otpVerified) {
      this.setState({ otpVerified: true })
    }
  }

  hideMissingSignFormAlert = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      this.props.changePage(ROUTES.PROFILE.USER_HRMW_FORM_ROUTE);
      this.props.hrmw.setfromPaperless(true);
      this.setState({ missingSignFormAlert: false })
      this.props.paperless.setAcceptAndProceed(false);
    }
  }

  //Modal to show Missing document to sign the HRMW form
  missingSignFormModal = () => {
    const { i18n: { messages } } = this.props;
    return (
      <div className="small-12 row padding-20">
        <div tabIndex={0} className="row">
          {messages['app.profile.paperless.missingDoc.desc']}
        </div>
        <div tabIndex={0} className="row padding-top-5">
          {messages['app.profile.paperless.missingDoc.proceed.btn']}
        </div>
        <div className="text-right margin-top-10">
          <Button size='large' tertiary className="mt-20" onClick={() => this.setState({ missingSignFormAlert: false })} >
            {messages['app.common.alert.no']}
          </Button>
          <Button size='large' className="mt-20" onKeyDown={(e) => this.hideMissingSignFormAlert(e)} onClick={() => this.hideMissingSignFormAlert()} >
            {messages['app.common.alert.yes']}
          </Button>
        </div>
      </div>
    )
  }

  bpSelected = async (row, e) => {
    if(isEnterorSpaceKeyPressed(e)){
      await this.props.hrmw.setBpId(row.bpId);
      this.props.paperless.setAcceptAndProceed(false);
      if (row.signedByAH) {
        this.setState({ goPaperLessPopup: true });
      } else {
        this.setState({ missingSignFormAlert: true });
      }
      if(document.querySelector('.modal__header-container')){
        document.querySelector('.modal__header-container').focus();
      }
    }
  }

  renderStatus = (messages, item) => {

    if (item.paperlessOptinStatus === PAPERLESS_OPT_IN_STATUS.YES) {
      return <Text size="large" tabIndex={0} className="activestatus">{messages['app.profile.paperless.active']}</Text>
    } else if (item.paperlessOptinStatus === PAPERLESS_OPT_IN_STATUS.NO) {
      let popoverText;

      if (item.singleAH && item.role.roleId === MANAGE_CONTACT_DETAILS_CONSTANTS.MANAGE_CONTACT_DETAILS_ACCOUNT_HOLDER) {
        return <Text size="large" tabIndex={0}>{messages['app.profile.paperless.request']}</Text>
      }

      if (!item.singleAH) {
        popoverText = messages['app.profile.paperless.request.tooltip.multipleAccnt'];
      }

      if (item.singleAH && item.role.roleId !== MANAGE_CONTACT_DETAILS_CONSTANTS.MANAGE_CONTACT_DETAILS_ACCOUNT_HOLDER) {
        popoverText = messages['app.profile.paperless.request.tooltip.accntHolder'];
      }

      return (
        <div className="iconrequest"><Text size="large" tabIndex={0} secondary>{messages['app.profile.paperless.request']}</Text>
          {
            <Popover
              mode="popup"
              orientation="top"
              showOnHover
              testID={`popover_paperless_settings_model_test`}
              accessibilityLabel={`popover_paperless_settings_model_test`}
              popOverClassName="manage-details-action-content"
              content={
                <div tabIndex={0} testID={`popover_paperless_settings_model_test`} accessibilityLabel={`popover_paperless_settings_model_test`}>
                  {popoverText}
                </div>
              }
            >   
            <div aria-label={popoverText}>
              <Info2 height={20} width={20} color={PALETTE.primaryText} />
            </div>
            </Popover>
          }
        </div>
      )
    }
    else if (item.paperlessOptinStatus === PAPERLESS_OPT_IN_STATUS.PENDING) {
      return (
        <Text size="large" tabIndex={0} style={{ color: PALETTE.paymentPending }}>{messages['app.profile.paperless.pending']}</Text>
      )
    }
  }

  renderButton = (messages, item) => {
    const { auth } = this.props;

    if (!auth.settingsDisabled && item.paperlessOptinStatus === PAPERLESS_OPT_IN_STATUS.NO && item.singleAH && item.role.roleId === MANAGE_CONTACT_DETAILS_CONSTANTS.MANAGE_CONTACT_DETAILS_ACCOUNT_HOLDER) {
      return (
        <div><Button size="large" onKeyDown={(e) => this.bpSelected(item, e)} onClick={() => this.bpSelected(item)}>{messages['app.profile.paperless.activate']}</Button></div>
      )
    }
  }

  handleAcceptAndProceed = () => {
    this.props.paperless.setAcceptAndProceed(!this.props.paperless.acceptAndProceed);
  }

  handleModalOnClose = () => {
    this.setState({ goPaperLessPopup: false });
    this.props.paperless.setAcceptAndProceed(false);
  }

  goToManageContactDetails = () => {
    this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
    this.props.hrmw.setfromPaperless(true);
    this.setState({ goPaperLessPopup: false });
  }

  renderGoPaperLessPopup = () => {
    return (
      <Modal
        isActive={this.state.goPaperLessPopup}
        onClose={() => { this.handleModalOnClose() }}
        header={this.props.i18n.messages["app.edelivery.title"]}
        title={this.props.i18n.messages["app.edelivery.title"]}
        content={
          <div className="padding-20">
            <div className="row text-indent">
              <Checkbox onChange={() => this.handleAcceptAndProceed()} className="pad-right-10" />
              <Large tabIndex={0}>{this.props.i18n.messages["app.profile.paperless.toReceivePaperlessStatements"]}</Large>
            </div>
            <div className="text-right margin-top-20">
              <Button size="large" disabled={!this.props.paperless.acceptAndProceed} onPress={() => this.goToManageContactDetails()}>
                {this.props.i18n.messages["app.manageContactDetails.hrmwFormAcceptbutton"]} </Button>
            </div>
          </div>}
      />
    )
  }
  closeDismissableBar = (obj, key) => {
    this.setState({ otpVerified: false });
  }

  render() {

    const { i18n: { messages }, paperless: { bpListData, showSpinner } } = this.props;

    if (showSpinner) {
      return <LoadingCircle />
    }
    const limitError = {
      errorDesc: messages['app.profile.paperless.goPaperlessRequest'],
    };

    return (
      <div className="row">
        {this.props.paperless.isEdocumentFlow && this.state.otpVerified && <DismissableBar error={limitError} keyValue={0} closeDismissableBar={this.closeDismissableBar} />}
        <div className="columns small-12 large-12  profile-container">
          <div className="profile-container__title" id="title_paperlessSetting_test">
            <H1 tabIndex={0} id="title_paperlessSetting_title_test">{messages['app.profile.paperless.title']}</H1>
          </div>
          <div>

            <div tabIndex={0}>
              <Text size="big">{messages['app.hrmw.accountForPaperless']}</Text>
            </div>
            <div tabIndex={0} className="instruction padding-bottom-20">
             <Text size="large">{messages['app.hrmw.goPaperlessInstruction']}</Text>
            </div>
            <div className='paperless-columns'>
              <div tabIndex={0}>
                <Text size="large" secondary className="columns small-3 medium-2 large-3 padding-left-25">{messages['app.hrmw.account']}</Text>
              </div>
              <div tabIndex={0}>
               <Text size="large" secondary className="columns small-4 medium-4 large-4 leftTextAligned padding-left-20">{messages['app.hrmw.role']}</Text>
              </div>
              <div tabIndex={0}>
               <Text size="large" secondary className="columns small-3 medium-2 large-3 leftTextAligned">{messages['app.trade.label.status']}</Text>
              </div>
              <div>
                <span className="columns small-2 medium-2 large-2 text-center">{ }</span>
              </div>
            </div>
            {Array.isArray(bpListData) ?
              <NavigationList fullWidth className="settings-list small-12 medium-12 large-12"  >
                {bpListData.map((item) => (
                  <NavigationListItem role="none" tabIndex={-1} className="column small-12 medium-12 large-12" hasArrow={false} disabled >
                    <Text size="large" tabIndex={0} className="columns small-3 medium-2 large-3">{item.bpId}</Text>
                    <Text size="large" tabIndex={0} className="columns small-4 medium-4 large-4">{item.role.roleDescription}</Text>
                    {/* todo : add all other conditions */}
                    <div className="columns small-3 medium-2 large-3">
                      {this.renderStatus(messages, item)}</div>
                    <div className="columns small-2 medium-4 large-2">{this.renderButton(messages, item)}</div>
                  </NavigationListItem>
                ))}
              </NavigationList>
              : <div className="columns small-12 medium-12 large-12 noData">
                {messages['app.manageContactDetails.noData']}
              </div>}

            <BlurModal
              visible={this.state.missingSignFormAlert || this.state.signHrmwAlert}
              header={
                <div className="error-message-container">
                  <NotificationWarning color={PALETTE.secondaryActive} className="error-icon" width={25} height={25} />
                  <Text size="large" className="error-message-content">{messages['app.manageContactDetails.missingDocument']}</Text>
                </div>}
              onDone={() => this.setState({ missingSignFormAlert: false })}
              size="large"
            >
              {this.missingSignFormModal()}
            </BlurModal>
          </div>
          {this.props.paperless.isEdocumentFlow && this.state.goPaperLessPopup && this.renderGoPaperLessPopup()}
        </div>
      </div>
    );
  }
};

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage />,
  $queries: {
    i18n: {
      messages: true,
    },
    hrmw: {
      setBpId: { $call: 'setBpId' },
      otpVerified: true,
      setOtpVerified: { $set: 'otpVerified' },
      resetFormStatus: { $call: 'resetFormStatus' },
      setfromPaperless: { $call: 'setfromPaperless' },
    },
    auth: {
      settingsDisabled: true
    },
    paperless: {
      getPaperlessBPList: { $call: 'getPaperlessBPList' },
      bpListData: true,
      showSpinner: true,
      acceptAndProceed: true,
      setAcceptAndProceed: { $set: 'acceptAndProceed' },
      isEdocumentFlow: true,
      setIsPaperlessSettingsPage: { $set: 'isPaperlessSettingsPage' },
    },
    changePage: { $call: 'ui.history.push' },
  },
})(PaperlessSettings);
